import { setPathValues } from 'src/i18n/lib/texts/keysUtils'

export const msg = {
    // WEB
    ui: {
        meta: {
            description: '',
            title: ''
        },
        toast: {
            savedSuccessfully: '',
            error: ''
        },
        nav: {
            items: {
                home: '',
                competition: '',
                shipments: '',
                boxes: '',
                help: '',
                franchising: '',
                tradingTerms: '',
                gdpr: '',
                storePolicy: '',
                login: '',
                logout: ''
            },
            callUs: ''
        },
        map: {
            search: {
                button: '',
                placeholder: '',
                noLocationAccess: '',
                showMap: '',
                showWarehouseList: ''
            },
            myPosition: '',
            warehouseItem: {
                cta: ''
            }
        },
        franchising: {
            fullName: '',
            email: '',
            phoneNumber: '',
            businessExperience: '',
            currentPositionAndArea: '',
            propertyStatus: '',
            propertyAreaInM2: '',
            cityToOpen: '',
            capitalInvestment: '',
            returnOnInvestment: '',
            isPrimaryIncome: '',
            hasReadFranchiseBrochure: '',
            motivation: '',
            submit: '',
            success: '',
            successTitle: '',
            successButton: ''
        },
        myZone: {
            items: {
                myProfile: '',
                myContracts: '',
                myBoxes: '',
                mySharedBoxes: '',
                rents: ''
            }
        },
        footer: {
            contactColumn: {
                title: '',
                leaveUsMessage: '',
                whatsApp: '',
                whatsAppText: '',
                openHours: {
                    title: '',
                    text: ''
                }
            },
            pagesColumn: {
                title: ''
            },
            infoColumn: {
                title: '',
                ico: '',
                dic: '',
                icDph: '',
                iban: '',
                membershipTitle: ''
            },
            appCardColumn: {
                appTitle: '',
                cardTitle: ''
            },
            copyright: '',
            version: ''
        },
        cookieBar: {
            title: '',
            preferences: '',
            text: '',
            save: '',
            moreInformation: '',
            essential: {
                title: '',
                text: '',
                includes: {
                    cookies: '',
                    map: ''
                }
            },
            nonEssential: {
                title: '',
                text: '',
                includes: {
                    analytics: '',
                    ads: '',
                    behaviour: ''
                }
            },
            accept: '',
            acceptAll: '',
            cookiesLink: '',
            detail: {
                title: '',
                caption: '',
                show: '',
                hide: '',
                columns: {
                    name: '',
                    type: '',
                    expires: ''
                },
                type: {
                    cookie: '',
                    localStorage: '',
                    sessionStorage: ''
                }
            },
            inventory: {
                essential: { label: '', purpose: '', expires: '' },
                marketing: { label: '', purpose: '', expires: '' },
                cookie_consent: { label: '', purpose: '', expires: '' },
                storage_data_version: { label: '', purpose: '', expires: '' },
                auth_token: { label: '', purpose: '', expires: '' },
                deviceId: { label: '', purpose: '', expires: '' },
                deviceToken: { label: '', purpose: '', expires: '' },
                uss_id: { label: '', purpose: '', expires: '' },
                order: { label: '', purpose: '', expires: '' },
                user_lang: { label: '', purpose: '', expires: '' },
                infoMessages: { label: '', purpose: '', expires: '' },
                coords: { label: '', purpose: '', expires: '' },
                coordsTimestamp: { label: '', purpose: '', expires: '' },
                geoOverride: { label: '', purpose: '', expires: '' },
                geoAllowed: { label: '', purpose: '', expires: '' },
                setRedirect: { label: '', purpose: '', expires: '' },
                suppressOverdueModalOnce: {
                    label: '',
                    purpose: '',
                    expires: ''
                },
                imfo_tab_seen: { label: '', purpose: '', expires: '' },
                _ga: { label: '', purpose: '', expires: '' },
                _ga_prefix: { label: '', purpose: '', expires: '' },
                _gcl_au: { label: '', purpose: '', expires: '' },
                _gcl_aw: { label: '', purpose: '', expires: '' },
                _gcl_dc: { label: '', purpose: '', expires: '' },
                _fbp: { label: '', purpose: '', expires: '' },
                ecomail: { label: '', purpose: '', expires: '' },
                _fbc: { label: '', purpose: '', expires: '' },
                gclid: { label: '', purpose: '', expires: '' },
                fbclid: { label: '', purpose: '', expires: '' },
                _clck: { label: '', purpose: '', expires: '' },
                _clsk: { label: '', purpose: '', expires: '' }
            }
        },
        back: '',
        returnToOrder: '',
        select: {
            noOptions: ''
        },
        specialOffer: {
            banner: '',
            detail: ''
        },
        notFound: {
            title: '',
            subTitle: '',
            redirect: '',
            homepage: ''
        },
        v2Lock: {
            title: {
                locked: '',
                unlocked: ''
            },
            button: {
                unlock: '',
                unlocked: ''
            },
            warehouseAccess: '',
            warehouseAccessBackup: '',
            boxAccess: ''
        },
        WarehouseStats: {
            discountDisclaimer: ''
        },
        cta: {
            goToBranch: '',
            gotIt: '',
            update: '',
            learnMore: ''
        },

        infoMsg: {
            system: {
                maintenance: {
                    title: '',
                    text: ''
                },
                serverIssue: {
                    title: '',
                    text: ''
                },
                accessIssue: {
                    title: '',
                    text: ''
                },
                appUpdate: {
                    title: '',
                    text: ''
                },
                webUpdate: {
                    title: '',
                    text: ''
                }
            },
            transaction: {
                recurringSuccess: {
                    title: '',
                    text: ''
                },
                reservationEnding: {
                    title: '',
                    text: ''
                },
                unpaidInvoice: {
                    title: '',
                    text: ''
                },
                overduePayment: {
                    title: '',
                    text: ''
                },
                overdueBlocked: {
                    title: '',
                    text: ''
                }
            },
            marketing: {
                newBranch: {
                    title: '',
                    text: ''
                },
                newFeature: {
                    title: '',
                    text: ''
                },
                promoDiscount: {
                    title: '',
                    text: ''
                },
                personalizedOffer: {
                    title: '',
                    text: ''
                },
                branchOpen: {
                    title: '',
                    text: ''
                }
            },
            educational: {
                appTip: {
                    title: '',
                    text: ''
                },
                safetyTip: {
                    title: '',
                    text: ''
                },
                reminder: {
                    title: '',
                    text: ''
                },
                featureSpotlight: {
                    title: '',
                    text: ''
                }
            },
            context: {
                nearbyBranch: {
                    title: '',
                    text: ''
                },
                behaviorNotice: {
                    title: '',
                    text: ''
                }
            },
            oznamTitle: ''
        }
    },
    // CORE
    monetary: {
        price: {
            from: '',
            fromPlain: '',
            to: '',
            month: '',
            perMonth: '',
            perMonthSpace: '',
            isFirstMonthFree: '',
            rangePerMonth: '',
            fromPerMonth: '',
            saving: '',
            insuranceUpTo: '',
            insuranceUpToShort: '',
            insuranceZeroPrice: '',
            savingPercent: ''
        },
        label: {
            priceRange: ''
        },
        VAT: {
            included: '',
            notIncluded: ''
        }
    },
    // CORE
    Warehouse: {
        locationInfo: {
            BUX: ''
        },
        loadMore: '',
        show: '',
        hide: '',
        attributes: {
            feature: '',
            delivery: ''
        },
        features: {
            barrierFreeEntrance: '',
            nonstopEntry: '',
            heating: '',
            parking: '',
            smart: '',
            videomonitoring: '',
            firstMonthFreeDiscountRequired: '',
            cooperationWithPlusim: ''
        },
        actions: {
            navigateFull: '',
            navigateAria: ''
        },
        alternative: '',
        rent: '',
        freeBoxes: '',
        notFree: '',
        notFreeTitle: '',
        notFreeSubTitle: '',
        notFreeButton: '',
        notFreeAlreadyRegistred: '',
        unavailable: {
            list: '',
            detail: '',
            notFreeBoxes: '',
            availableFrom: ''
        },
        notFound: '',
        tabs: {
            boxes: '',
            floorPlan: ''
        },
        floorPlan: {
            availableBoxes: '',
            notAvailableBoxes: '',
            busy: '',
            inactive: '',
            orderButton: ''
        },
        usageExamples: {
            title: '',
            button: '',
            backButton: '',
            cta: '',
            price: ''
        }
    },
    WarehouseInfo: {
        entity: {
            attr: {
                name: '',
                address: '',
                addressNote: ''
            }
        }
    },
    ServiceAssess: {
        title: '',
        invalidLink: '',
        expiredToken: '',
        validFrom: '',
        validTo: '',
        notYetValid: ''
    },
    QrAccess: {
        title: '',
        text: '',
        invalidLink: '',
        openButton: '',
        successTitle: '',
        openingFailed: '',
        locationDenied: ''
    },
    // CORE
    Box: {
        rent: '',
        name: '',
        id: '',
        rentFrom: '',
        typeAndSize: '',
        location: '',
        list: '',
        area: {
            name: '',
            valueWithDimensions: '',
            numberOfActiveBoxes: '',
            sizeRange: ''
        },
        size: {
            XS: {
                name: {
                    singular: '',
                    plural: ''
                },
                value: ''
            },
            SMALL: {
                name: {
                    singular: '',
                    plural: ''
                },
                value: ''
            },
            MEDIUM: {
                name: {
                    singular: '',
                    plural: ''
                },
                value: ''
            },
            LARGE: {
                name: {
                    singular: '',
                    plural: ''
                },
                value: ''
            }
        },
        filter: {
            all: ''
        },
        entity: {
            attr: {
                name: ''
            }
        }
    },
    BoxDimensions: {
        sizeGuide: '',
        illustrationAlt: '',
        sizeFits: {
            XS: '',
            SMALL: '',
            MEDIUM: '',
            LARGE: ''
        },
        entity: {
            attr: {
                area: ''
            }
        },
        info: ''
    },
    // WEB
    Order: {
        steps: {
            first: {
                title: ''
            },
            second: {
                title: {
                    continueWithoutLogin:
                        'Order.steps.second.title.continueWithoutLogin',
                    invoicingDetails:
                        'Order.steps.second.title.invoicingDetails'
                }
            },
            third: {
                title: '',
                total: '',
                next: '',
                paymentFailedButton: '',
                paymentInfo: '',
                discountInfo: ''
            },
            next: '',
            autoregistrationHint: ''
        },
        statusPage: {
            pending: '',
            undetermined: {
                text: '',
                link: ''
            }
        },
        invoicing: {
            period: {
                one: '',
                three: '',
                six: '',
                twelve: '',
                n: ''
            },
            periodMonths: {
                one: '',
                few: '',
                n: ''
            },
            chooseOption: '',
            bestDealBadge: '',
            savedAmountWholePeriod: '',
            selectedOption: '',
            details: '',
            supplier: '',
            saleDisclaimer: {
                first: '',
                second: ''
            },
            deposit: '',
            depositTooltip: '',
            depositOneUnit: '',
            firstMonthFree: {
                title1: '',
                title2: ''
            }
        },
        insurance: {
            chooseOption: '',
            selectedOption: '',
            heading: '',
            valueQuestion: '',
            valueInstruction: '',
            basicCoverage: '',
            standardCoverage: '',
            premiumCoverage: '',
            basicDescription: '',
            standardDescription: '',
            premiumDescription: '',
            payoutTo: '',
            mobileDescription: '',
            perMonthShort: '',
            boxcareIncluded: '',
            boxcareCctv: '',
            boxcareAccess: '',
            boxcareAlways: '',
            boxcareRecords: '',
            boxcareSupport: '',
            boxcareDescription: '',
            boxcareSelectionHint: '',
            termsText: '',
            termsLink: ''
        },
        paymentStatus: {
            success: '',
            fail: ''
        },
        help: {
            text: '',
            link: ''
        },
        voucherToken: '',
        voucherTokenDescription: '',
        voucherTokenPlaceholder: '',
        voucherTokenApply: '',
        summary: {
            boxName: '',
            dimensions: '',
            location: '',
            rentalOverview: '',
            checkRentalDetails: '',
            agreementsAndTerms: '',
            paymentRecap: '',
            monthlyRate: '',
            savings: '',
            rentForMonths: '',
            withoutVat: '',
            monthlyCalc: '',
            monthlyCalcOne: '',
            priceWithVatBox: '',
            insuranceWithCoverage: '',
            totalDueNow: '',
            withVat: '',
            continueToRecap: '',
            paymentSecurityInfo: '',
            fullName: '',
            permanentAddress: '',
            companyName: '',
            companyIdentifiers: ''
        }
    },
    // CORE
    Invoice: {
        items: {
            count: '',
            subject: '',
            totalPrice: '',
            totalPriceWithVat: '',
            unitPrice: '',
            vat: ''
        }
    },
    // CORE
    InvoicingDetails: {
        entity: {
            attr: {
                firstName: '',
                lastName: '',
                email: '',
                telephoneNumber: '',
                personalId: '',
                type: ''
            }
        },
        telephoneNumberPlaceholder: ''
    },
    // CORE
    enum: {
        InvoicingDetails$Type: {
            FyzickaOsoba: '',
            PravnickaOsoba: ''
        },
        ClientUser$Gender: {
            Male: '',
            Female: ''
        },
        Contract$Status: {
            ACTIVE: '',
            TERMINATING: '',
            EVICTED: '',
            TERMINATED: ''
        },
        CountryCode: {
            ABW: '',
            AFG: '',
            AGO: '',
            AIA: '',
            ALA: '',
            ALB: '',
            AND: '',
            ARE: '',
            ARG: '',
            ARM: '',
            ASM: '',
            ATA: '',
            ATF: '',
            ATG: '',
            AUS: '',
            AUT: '',
            AZE: '',
            BDI: '',
            BEL: '',
            BEN: '',
            BES: '',
            BFA: '',
            BGD: '',
            BGR: '',
            BHR: '',
            BHS: '',
            BIH: '',
            BLM: '',
            BLR: '',
            BLZ: '',
            BMU: '',
            BOL: '',
            BRA: '',
            BRB: '',
            BRN: '',
            BTN: '',
            BVT: '',
            BWA: '',
            CAF: '',
            CAN: '',
            CCK: '',
            CHE: '',
            CHL: '',
            CHN: '',
            CIV: '',
            CMR: '',
            COD: '',
            COG: '',
            COK: '',
            COL: '',
            COM: '',
            CPV: '',
            CRI: '',
            CUB: '',
            CUW: '',
            CXR: '',
            CYM: '',
            CYP: '',
            CZE: '',
            DEU: '',
            DJI: '',
            DMA: '',
            DNK: '',
            DOM: '',
            DZA: '',
            ECU: '',
            EGY: '',
            ERI: '',
            ESH: '',
            ESP: '',
            EST: '',
            ETH: '',
            FIN: '',
            FJI: '',
            FLK: '',
            FRA: '',
            FRO: '',
            FSM: '',
            GAB: '',
            GBR: '',
            GEO: '',
            GGY: '',
            GHA: '',
            GIB: '',
            GIN: '',
            GLP: '',
            GMB: '',
            GNB: '',
            GNQ: '',
            GRC: '',
            GRD: '',
            GRL: '',
            GTM: '',
            GUF: '',
            GUM: '',
            GUY: '',
            HKG: '',
            HMD: '',
            HND: '',
            HRV: '',
            HTI: '',
            HUN: '',
            IDN: '',
            IMN: '',
            IND: '',
            IOT: '',
            IRL: '',
            IRN: '',
            IRQ: '',
            ISL: '',
            ISR: '',
            ITA: '',
            JAM: '',
            JEY: '',
            JOR: '',
            JPN: '',
            KAZ: '',
            KEN: '',
            KGZ: '',
            KHM: '',
            KIR: '',
            KNA: '',
            KOR: '',
            KWT: '',
            LAO: '',
            LBN: '',
            LBR: '',
            LBY: '',
            LCA: '',
            LIE: '',
            LKA: '',
            LSO: '',
            LTU: '',
            LUX: '',
            LVA: '',
            MAC: '',
            MAF: '',
            MAR: '',
            MCO: '',
            MDA: '',
            MDG: '',
            MDV: '',
            MEX: '',
            MHL: '',
            MKD: '',
            MLI: '',
            MLT: '',
            MMR: '',
            MNE: '',
            MNG: '',
            MNP: '',
            MOZ: '',
            MRT: '',
            MSR: '',
            MTQ: '',
            MUS: '',
            MWI: '',
            MYS: '',
            MYT: '',
            NAM: '',
            NCL: '',
            NER: '',
            NFK: '',
            NGA: '',
            NIC: '',
            NIU: '',
            NLD: '',
            NOR: '',
            NPL: '',
            NRU: '',
            NZL: '',
            OMN: '',
            PAK: '',
            PAN: '',
            PCN: '',
            PER: '',
            PHL: '',
            PLW: '',
            PNG: '',
            POL: '',
            PRI: '',
            PRK: '',
            PRT: '',
            PRY: '',
            PSE: '',
            PYF: '',
            QAT: '',
            REU: '',
            ROU: '',
            RUS: '',
            RWA: '',
            SAU: '',
            SDN: '',
            SEN: '',
            SGP: '',
            SGS: '',
            SHN: '',
            SJM: '',
            SLB: '',
            SLE: '',
            SLV: '',
            SMR: '',
            SOM: '',
            SPM: '',
            SRB: '',
            SSD: '',
            STP: '',
            SUR: '',
            SVK: '',
            SVN: '',
            SWE: '',
            SWZ: '',
            SXM: '',
            SYC: '',
            SYR: '',
            TCA: '',
            TCD: '',
            TGO: '',
            THA: '',
            TJK: '',
            TKL: '',
            TKM: '',
            TLS: '',
            TON: '',
            TTO: '',
            TUN: '',
            TUR: '',
            TUV: '',
            TWN: '',
            TZA: '',
            UGA: '',
            UKR: '',
            UMI: '',
            URY: '',
            USA: '',
            UZB: '',
            VAT: '',
            VCT: '',
            VEN: '',
            VGB: '',
            VIR: '',
            VNM: '',
            VUT: '',
            WLF: '',
            WSM: '',
            YEM: '',
            ZAF: '',
            ZMB: '',
            ZWE: ''
        },
        Language: {
            SK: '',
            CS: '',
            EN: '',
            UK: '',
            PL: '',
            HU: '',
            RO: '',
            IT: '',
            DE: ''
        },
        ContractCancellationRequest$Reason: {
            PotrebujemPriestoryBlizsie: '',
            NevyhovujeMiCena: '',
            NevyhovujeMiVelkostPriestoru: '',
            UzNepotrebujem: '',
            Ine: ''
        },
        IsMainIncome: {
            Yes: '',
            No: ''
        },
        HasReadFranchiseBrochure: {
            Yes: '',
            No: ''
        }
    },
    // WEB
    myZone: {
        newsletter: {
            title: ''
        },
        myContracts: {
            title: '',
            detail: {
                title: '',
                cancelContract: '',
                confirmEviction: '',
                unsolvedCancellationRequest: ''
            },
            cancel: {
                title: '',
                day: '',
                dayPlaceholder: '',
                dayHint: {
                    text: '',
                    link: ''
                },
                dayError: '',
                reason: '',
                notePlaceholder: '',
                submit: '',
                submitSuccess: '',
                requestAlreadySubmitted: ''
            },
            eviction: {
                title: '',
                submit: '',
                submitSuccess: '',
                requestAlreadySubmitted: ''
            },
            showLockCode: '',
            hideLockCode: '',
            showBoxNumber: '',
            hideBoxNumber: ''
        },
        myBoxes: {
            popup: {
                deniedLocation: {
                    heading: '',
                    text: '',
                    button: ''
                },
                safariPreciseLocation: {
                    heading: '',
                    text: '',
                    button: ''
                }
            },
            locationAccessCheck: {
                text: ''
            },
            noBoxes: '',
            sharedBoxes: {
                title: '',
                email: '',
                submit: '',
                submitSuccess: '',
                sharedClients: '',
                confirmTitle: '',
                confirm: '',
                reject: ''
            }
        },
        myRents: {
            title: '',
            pay: '',
            paymentOverdueTitle: '',
            paymentOverdueText: ''
        }
    },
    Newsletter: {
        subscribe: {
            title: '',
            text1: '',
            text2: '',
            text3: ''
        }
    },
    // CORE
    MyContract: {
        entity: {
            attr: {
                businessId: '',
                boxName: '',
                createdAt: '',
                terminationAt: '',
                status: '',
                totalPrice: '',
                insurance: {
                    coverage: ''
                },
                accessCode: '',
                lockCode: ''
            }
        },
        terminationNotSpecified: '',
        filter: {
            country: {
                label: '',
                placeholder: ''
            },
            status: {
                label: '',
                placeholder: ''
            }
        }
    },
    // CORE
    MyRent: {
        entity: {
            attr: {
                contractId: '',
                boxName: '',
                issuedOn: '',
                amount: '',
                status: '',
                paidAt: ''
            }
        },
        filter: {
            state: {
                label: '',
                placeholder: '',
                options: {
                    unpaid: '',
                    paidInYear: ''
                }
            }
        },
        invoice: ''
    },
    VatPrice: {
        entity: {
            attr: {
                priceWithVat: ''
            }
        }
    },
    // CORE
    DayInterval: {
        entity: {
            attr: {
                from: '',
                to: ''
            }
        }
    },
    // CORE
    ContractInvoicingType: {
        entity: {
            attr: {
                periodInMonths:
                    'ContractInvoicingType.entity.attr.periodInMonths'
            }
        }
    },
    // CORE
    ClientUser: {
        entity: {
            attr: {
                firstName: '',
                lastName: '',
                email: '',
                phoneNumber: '',
                dateOfBirth: '',
                personalId: '',
                gender: ''
            }
        }
    },
    // CORE
    Address: {
        entity: {
            attr: {
                street: '',
                number: '',
                city: '',
                zip: '',
                countryCode: ''
            }
        }
    },
    // CORE
    CompanyDetails: {
        entity: {
            attr: {
                name: '',
                ico: '',
                dic: '',
                icoDph: ''
            }
        }
    },
    Owner: {
        entity: {
            attr: {
                email: '',
                phoneNumber: ''
            }
        }
    },
    consentCheckboxes: {
        tradingTerms: {
            text: '',
            link: ''
        },
        automaticPayment: {
            text: '',
            link: '',
            suffix: '',
            nopromo: ''
        },
        gdpr: {
            text: '',
            link: ''
        },
        italianLawApproval: {
            text: ''
        }
    },
    auth: {
        user: {
            username: '',
            usernamePlaceholder: '',
            password: '',
            passwordAria: '',
            passwordPlaceholder: '',
            passwordHelpPlaceholder: '',
            passwordConfirmation: '',
            oldPassword: '',
            newPassword: '',
            newPasswordConfirmation: '',
            rememberMe: ''
        }
    },
    // WEB
    loginPage: {
        title: '',
        registrationCta: {
            text: '',
            action: ''
        },
        resetPasswordCta: {
            action: ''
        },
        submit: '',
        redirect: ''
    },
    // WEB
    registrationPage: {
        title: {
            normal: '',
            success: ''
        },
        requiredInfo: '',
        success: {
            text: '',
            callToAction: {
                text: '',
                action: ''
            }
        },
        submit: ''
    },
    // WEB
    resetPasswordRequestPage: {
        title: '',
        success: {
            text: ''
        },
        submit: ''
    },
    // WEB
    resetPasswordChangePage: {
        title: '',
        success: {
            text: '',
            callToAction: {
                text: '',
                action: ''
            }
        },
        missingToken: '',
        submit: ''
    },
    // WEB
    removeAccountPage: {
        title: '',
        text: '',
        error: {
            text: ''
        },
        success: {
            text: ''
        },
        submit: ''
    },
    // WEB
    myProfilePage: {
        title: '',
        changePassword: '',
        cookies: '',
        removeAccount: '',
        formGroups: {
            contactDetails: '',
            personalDetails: '',
            invoicingDetails: ''
        },
        referral: '',
        submit: ''
    },
    // WEB
    changePasswordPage: {
        title: '',
        success: {
            text: ''
        },
        submit: ''
    },
    error: {
        unexpected: '',
        'invalid-credentials': '',
        'revalid/rule/basic/not-null': '',
        'revalid/rule/basic/regex': '',
        'phoneNumber-invalid': '',
        'aruba/telephone-invalid': '',
        'aruba/latin-invalid': '',
        'name/first-letter-uppercase': '',
        passwordsMustMatch: '',
        mustBeChecked: '',
        'registration/email-exists': '',
        'registration/phone-exists': '',
        'auth/invalid-password': '',
        'auth/login-incomplete': '',
        'Autoregistration/email-taken': '',
        'Autoregistration/phone-taken': '',
        'Box/is-taken': '',
        'Order/Warehouse-deactivated': '',
        'Order/Box-not-active': '',
        'sms/invalid-number': '',
        'password-reset/invalid-token': '',
        weApologize: '',
        'lock-v2/too-far-away': '',
        'cancelContract/unpaid-invoices': '',
        notFreeBox: ''
    },
    // WEB
    landingPage: {
        promo: {
            allPlansBanner: '',
            headline: '',
            taglinePart1: '',
            taglinePart2: '',
            subtitle: '',
            badge: {
                tryIt: '',
                monthFree: '',
                noCommitment: '',
                onAllPlans: ''
            }
        },
        hero: {
            title: {
                text: '',
                highlightedText: ''
            },
            text1: '',
            text2: '',
            textMobile: '',
            landingTextMobile: {
                title: '',
                text: ''
            }
        },
        search: {
            button: '',
            button2: '',
            button3: ''
        },
        tutorial: {
            title: '',
            option1: '',
            option2: '',
            option3: '',
            option4: '',
            option5: ''
        },
        orderSteps: {
            title: '',
            search: {
                title: '',
                text: ''
            },
            chooseBox: {
                title: '',
                text: ''
            },
            chooseRent: {
                title: '',
                text: ''
            },
            getCode: {
                title: '',
                text: ''
            }
        },
        getSpace: '',
        perks: {
            simplicity: {
                title: '',
                text: ''
            },
            nonstop: {
                title: '',
                text: ''
            },
            safe: {
                title: '',
                text: ''
            },
            flexible: {
                title: '',
                text: ''
            }
        },
        description: {
            title: '',
            subtitle1: '',
            text1: '',
            subtitle2: '',
            text2: '',
            subtitle3: '',
            text3: '',
            subtitle4: '',
            text4: ''
        },
        reviews: {
            review1: {
                title: '',
                author: '',
                text: ''
            },
            review2: {
                title: '',
                author: '',
                text: ''
            },
            review3: {
                title: '',
                author: '',
                text: ''
            },
            review4: {
                title: '',
                author: '',
                text: ''
            },
            review5: {
                title: '',
                author: '',
                text: ''
            },
            review6: {
                title: '',
                author: '',
                text: ''
            },
            review7: {
                title: '',
                author: '',
                text: ''
            },
            review8: {
                title: '',
                author: '',
                text: ''
            },
            review9: {
                title: '',
                author: '',
                text: ''
            },
            review10: {
                title: '',
                author: '',
                text: ''
            }
        }
    },
    helpPage: {
        contactUs: '',
        contactUsRo: '',
        contactHoursRo: ''
    },
    // CORE
    ClientReferralInfo: {
        url: '',
        totalContracts: ''
    },
    ReferralRewardAccountState: {
        entity: {
            attr: {
                balance: ''
            }
        }
    },
    title: {
        landing: '',
        boxes: '',
        location: ''
    },
    Infomessage: {
        modal: {
            button: ''
        }
    },
    chatbot: {
        chat: {
            placeholder: '',
            error: '',
            startConversation: '',
            sendMessage: '',
            clearedBecauseInactive: '',
            clearedTitle: '',
            idleWarningTitle: '',
            idleWarningBody: '',
            idleWarningAction: '',
            botunavailable: {
                title: '',
                message: ''
            },
            topic: {
                selfStorage: '',
                shipmentPickupOrSending: ''
            }
        },
        popup: {
            button: '',
            title: ''
        }
    },
    virtual360: {
        horizontal: ''
    },
    geoOverride: {
        popup: {
            heading: '',
            intro: '',
            confirmText: '',
            list1: '',
            list2: '',
            list3: '',
            agree: '',
            cancel: '',
            confirm: '',
            loading: '',
            unlockFailed: '',
            more: ''
        }
    },
    geo: {
        popup: {
            heading: '',
            body: '',
            allow: '',
            close: '',
            helpLink: ''
        }
    }
}

setPathValues(msg)
